import { eAppContext, LoginExtranetAppModel, LoginCustomAppModel, LoginData, ConnectedUser, LoginDate, eLogMode, LoginOut, SessionModel, QueovalDik, eLogOutMode, LoginQueovalAppModel, GlobalParams, LoginWebStoreAppModel } from '../models';
import { Observable, of, Subject } from 'rxjs';
import { b64EncodeUnicode, b64UrlEncodeUnicode, b64DecodeUnicode, EndWithSlash } from '../utilities';
import { CoreService } from '../services';
import { HttpClient } from '@angular/common/http';
import { mergeMap, catchError } from 'rxjs/operators';

export class LoginBaseService {

  //#region alerts list
  protected alert$: Subject<string> = new Subject();
  //#endregion

  //#region after login operation
  protected result$: Subject<LoginOut> = new Subject<LoginOut>();
  //#endregion


  constructor(
    protected indParam: CoreService,
    protected http: HttpClient
  ) {  }


  //#region alerts list
  setAlert(data: string): void {
    if (data !== '') {
      this.alert$.next(data);
    }
  }
  getAlert(): Observable<string> {
    return this.alert$.asObservable();
  }
  //#endregion

  //#region generic info communication
  setLoginResult(data: LoginOut): void {
    this.result$.next(data);
  }
  getLoginResult(): Observable<LoginOut> {
    return this.result$.asObservable();
  }
  clearLoginResult(): void {
    this.result$.next(new LoginOut(false, eLogOutMode.NONE));
  }
  //#endregion

   //#region login procedure
  Log(context: eAppContext, user: string, pswd: string, db: string, doubleencryption: boolean = false): Observable<string> {
    if (this.indParam.AppParams.apiLogin == "")
      this.indParam.AppParams.apiLogin = this.indParam.AppParams.apiUrl;

    switch (context) {
      case eAppContext.LOGINEX:
        const model1: LoginExtranetAppModel = new LoginExtranetAppModel();
        model1.UserName = doubleencryption ? user : b64EncodeUnicode(user);
        model1.Password = doubleencryption ? pswd : b64EncodeUnicode(pswd);
        model1.Source = 'EXTRANET';
        model1.DataSource = db;
        model1.IsdoubleEncryption = doubleencryption;
        return this.LoginApp<LoginExtranetAppModel>(this.indParam.AppParams.apiLogin, model1, context);

      case eAppContext.LOGINEL:
        const model2: LoginCustomAppModel = new LoginCustomAppModel();
        model2.username = doubleencryption ? user : b64EncodeUnicode(user);
        model2.password = doubleencryption ? pswd : b64EncodeUnicode(pswd);
        model2.appmode = 'FORM';
        model2.appname = 'ELEARNING';
        model2.datasource = db;
        model2.IsdoubleEncryption = doubleencryption;
        return this.LoginApp<LoginCustomAppModel>(this.indParam.AppParams.apiLogin, model2, context);

        case eAppContext.ELEARNING:
          const model3: LoginCustomAppModel = new LoginCustomAppModel();
          model3.username = b64EncodeUnicode(user);
          model3.password = b64EncodeUnicode(pswd);
          model3.appmode = 'FORM';
          model3.appname = db === '' ? 'ELEARNINGOLD' : 'ELEARNING';
          model3.datasource = db;
          return this.LoginApp<LoginCustomAppModel>(this.indParam.AppParams.apiLogin, model3, context);

        case eAppContext.QUESTIONNAIRE:
          const model4: LoginCustomAppModel = new LoginCustomAppModel();
          model4.username = doubleencryption ? user : b64EncodeUnicode(user);
          model4.password = doubleencryption ? pswd : b64EncodeUnicode(pswd);
          model4.appmode = 'FORM';
          model4.appname = db === '' ? 'QUESTIONOLD' : 'QUESTION';
          model4.IsdoubleEncryption = doubleencryption;
          model4.datasource = db;
          return this.LoginApp<LoginCustomAppModel>(this.indParam.AppParams.apiLogin, model4, context);

        case eAppContext.EXTRANET:

          const model5: LoginExtranetAppModel = new LoginExtranetAppModel();
          model5.UserName = doubleencryption ? user : b64EncodeUnicode(user);
          model5.Password = doubleencryption ? pswd : b64EncodeUnicode(pswd);
          model5.Source = db === '' ? 'EXTRANETOLD' : 'EXTRANET';
          model5.DataSource = db;
          model5.IsdoubleEncryption = doubleencryption;
          return this.LoginApp<LoginExtranetAppModel>(this.indParam.AppParams.apiLogin, model5, context);

        case eAppContext.QUEOVAL:
          const model6: LoginQueovalAppModel = new LoginQueovalAppModel();
          model6.Action = 'NEW';
          model6.Username = b64EncodeUnicode(user);
          model6.Password = b64EncodeUnicode(pswd);
          return this.LoginApp<LoginQueovalAppModel>(this.indParam.AppParams.apiLogin, model6, context);

        case eAppContext.ONLINEMARKETLOG:
          const model7: LoginWebStoreAppModel = new LoginWebStoreAppModel();
          model7.username = b64EncodeUnicode(user);
          model7.password = b64EncodeUnicode(pswd);
          model7.module = 'ONLINEMARKETLOG';
          model7.baseName = db;
          return this.LoginApp<LoginWebStoreAppModel>(this.indParam.AppParams.apiLogin, model7, context);

        default:
          return of('');
      }
  }

  protected LoginApp<T>(apiAddress: string, model: T, context: eAppContext): Observable<string> {
    const destUrl: string = `${EndWithSlash(apiAddress)}api/loginapp`;
    let destFullUrl: string = destUrl;
    switch (context) {
      case eAppContext.LOGINEX:
      case eAppContext.EXTRANET:
        destFullUrl = `${destUrl}/extranet`;
        break;
      case eAppContext.LOGINEL:
      case eAppContext.ELEARNING:
        destFullUrl = `${destUrl}/elearning`;
        break;
      case eAppContext.QUESTIONNAIRE:
        destFullUrl = `${destUrl}/questionnaire`;
        break;
      case eAppContext.QUEOVAL:
        destFullUrl = `${destUrl}/queoval`;
        break;
    }

    return this.http.post<LoginData>(destFullUrl, model).pipe(mergeMap((data: LoginData) => {
      if (data.HasError)
        return of(data.Error);
      if (data.HasAlert)
        return of(data.Alert);

      if (context === eAppContext.QUEOVAL) {
        // seulement pour  authentification a app-queoval
        // nous stockons temporairement InfoLoginData dans le locagstorage pour le rechargé dans base-list.component.ts of the app-login
        // NB: a ce point le  process d'authentification n'est pas fini completement (on a besoin de savoir sur quel base il va se connecter)
        this.indParam.stockData('LoginInfo', JSON.stringify(data.InfoLoginData));
        return of('OK');
      }
      this.indParam.AppParams.token = data.Token;
      this.indParam.AppParams.tokenApiAut = data.TokenAPIAuth;
      this.indParam.AppParams.dbname = data.ConnParams.DataBase;
      this.indParam.AppParams.culture = data.ConnParams.Culture ?? this.indParam.AppParams.culture ?? "fr-FR";
      this.indParam.AppParams.GMT = data.ConnParams.GMT ?? this.indParam.AppParams.GMT;
      this.indParam.AppParams.appLoginSite = data.ConnParams.HttpAppLogin;
      this.indParam.AppParams.Role = data.UserRole;
      this.indParam.AppParams.Translation = data.TranslationData;
      this.indParam.AppParams.ConfigKeys = data.ConfigKeys;
      this.indParam.AppParams.LoggedUser = new ConnectedUser();
      this.indParam.AppParams.LoggedUser.Ident = data.ConnParams.UserID;
      this.indParam.AppParams.LoggedUser.Conx_PER = data.ConnParams.UserName;
      if (this.indParam.AppParams.apiUrl === '')
        this.indParam.AppParams.apiUrl = apiAddress;

      this.indParam.AppParams.UrlSiteERP = data.ConnParams.UrlSiteERP;
      this.indParam.AppParams.UrlSiteERPWS = data.ConnParams.UrlSiteERPWS;

      this.indParam.AppParams.UrlExtranetSite = data.ConnParams.UrlExtranetSite;
      this.indParam.AppParams.UrlExtranetWS = data.ConnParams.UrlExtranetWS;

      this.indParam.AppParams.UrlElearningSite = data.ConnParams.UrlElearningSite;
      this.indParam.AppParams.UrlElearningWS = data.ConnParams.UrlElearningWS;

      this.indParam.AppParams.UrlQuestionnaireSite = data.ConnParams.UrlQuestionnaireSite;
      this.indParam.AppParams.UrlQuestionnaireWS = data.ConnParams.UrlQuestionnaireWS;

      this.indParam.AppParams.UrlOnlinemarketSite = data.ConnParams.UrlOnlinemarketSite;
      this.indParam.AppParams.UrlOnlinemarketWS = data.ConnParams.UrlOnlinemarketWS;

      this.indParam.LoginDate = new LoginDate();

      // traitement specifique
      switch (this.indParam.AppParams.context) {
        case eAppContext.ESTORE:
          // pour "EStore": we stocked temporarely on the server-side the estore-token in the GoogleAccessToken property of the appParam
          // now we stock it temporarely in localStorage to add it to the EStore core service at the login subscription in the EStore app.component.ts
          localStorage.setItem('EST-TKN', data.ConnParams.Google.AccessToken);
          break;
        case eAppContext.ELEARNING:
          // récupération du booléen pou savoir s'il a accès aux différentes gestions réservés à certains rôles
          this.indParam.AppParams.IsAuthorizedAccess = data.ConnParams.IsAuthorizedAccess;
          // login redirection on website specified in db_connect.tPA_ApiService
          if (data.ConnParams.DestinationSite) {
            this.indParam.stockData('EL-REDIRECT', data.ConnParams.DestinationSite);
            this.indParam.stockData('EL-REDIRECT-WS', data.ConnParams.DestinationSiteWS);
          }
          break;
        case eAppContext.EXTRANET:
          // login redirection on website specified in db_connect.tPA_ApiService
          if (data.ConnParams.DestinationSite) {
            this.indParam.stockData('EX-REDIRECT', data.ConnParams.DestinationSite);
            this.indParam.stockData('EX-REDIRECT-WS', data.ConnParams.DestinationSiteWS);
          }
          break;
        case eAppContext.ONLINEMARKETLOG:
          this.indParam.traductionSubject$.next(true);
          break;
      }

      return of('OK');
    }), catchError((error: Error) => {
      console.error('AUTHENTICATION ERROR: ');
      console.error(JSON.stringify(error));
      return of('Erreur sur le protocole d\'authentification');
    }));
  }
  //#endregion

  //#region aspx authentication
  addCookiesASP(): Observable<string> {
    if (this.indParam.AppParams.loginMode === eLogMode.MIXED) {
      const url: string = this.indParam.AppParams.dbname === ''
        ? `${this.indParam.AppParams.appUrl}nosecu/PageApiAuth.aspx/InitAuthAsp`
        : `${this.indParam.AppParams.appUrl}nosecu/PageApiAuth.aspx/InitAuthAsp2`;
      const body: any = this.indParam.AppParams.dbname === ''
        ? { name: b64EncodeUnicode(this.indParam.AppParams.LoggedUser.Conx_PER) }
        : { name: b64EncodeUnicode(this.indParam.AppParams.LoggedUser.Conx_PER), dbname: this.indParam.AppParams.dbname };

      // old version
      return this.http.post<any>(url, body).pipe(mergeMap((data: any) => {
        if (data && data.d && data.d === 'OK')
          return of('OK');
        else {
          return of(data);
        }
      }), catchError((error: Error) => {
        console.error(JSON.stringify(error));
        return of(`Erreur sur la création de cookies d'authentification aspx`);
      }));
    }
    else
      return of('OK');
  }

  public getSessionData(appData: string): Observable<QueovalDik> {
    if (appData === '')
      return of(new QueovalDik('ERROR', 'token not found'));

    const d1: string = b64DecodeUnicode(appData);
    const da: string[] = d1.split('|');
    if (da.length !== 3)
      return of(new QueovalDik('ERROR', 'invalid token'));

    const p1: string = b64UrlEncodeUnicode(da[0]);
    const p2: string = b64UrlEncodeUnicode(da[1]);
    const p3: string = b64UrlEncodeUnicode(da[2]);

    return this.http.get<SessionModel>(`${this.indParam.AppParams.apiUrl}api/loginapp/datasession/${p1}/${p2}/${p3}`).pipe(mergeMap((data: SessionModel) => {
      if (!data.HasError) {
        const d: string = b64DecodeUnicode(data.Value);
        const returnedAppParam: GlobalParams = JSON.parse(d);
        if (this.indParam.AppParams.apiUrl && this.indParam.AppParams.apiUrl !== '' && this.indParam.AppParams.apiUrl !== returnedAppParam.apiUrl)
          returnedAppParam.apiUrl = this.indParam.AppParams.apiUrl;
        if (this.indParam.AppParams.appUrl && this.indParam.AppParams.appUrl !== '' && this.indParam.AppParams.appUrl !== returnedAppParam.appUrl)
          returnedAppParam.appUrl = this.indParam.AppParams.appUrl;
        this.indParam.AppParams = returnedAppParam;
        this.setLoginResult(new LoginOut(true, eLogOutMode.EXTRANETAPPLOGIN));
        return of(new QueovalDik('OK', ''));
      } else return of(new QueovalDik('ERROR', 'error on returning token from db'));
    }));
  }
}
